import 'core-js/stable'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { initializeIcons } from '@fluentui/font-icons-mdl2'
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons'
import App from '../pages/App'
import 'react-toastify/dist/ReactToastify.css'
import '../../assets/styles/Base.scss'
import initializeCommands from '../helpers/commandHelper'
import { isAppContext } from '../helpers/appHelper'
import { AppContext } from '../config/appConfig'
import store, { persistor } from '../store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { initializeI18N } from '../context/I18NContext'

try {
    initializeCommands()

    if (!isAppContext(AppContext.Command)) {
        const root = createRoot(document.getElementById('container'))
        navigator?.serviceWorker.register('/serviceworker.js')

        // Helper function from Office UI Fabric to load icons.
        initializeIcons()
        initializeFileTypeIcons()
        initializeI18N().then(() => {
            // Initialize the office API.
            return Office.onReady(() => {
                // This handler is required.
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                Office.context?.mailbox?.addHandlerAsync(Office.EventType.ItemChanged, () => {})
                root.render(
                    <Provider store={store}>
                        <PersistGate persistor={persistor}>
                            <App />
                        </PersistGate>
                    </Provider>,
                )
            })
        })
    }
} catch (e) {
    console.log('Uncaught exception', e)
}
